import { render } from "./ScrollablePanels.vue?vue&type=template&id=964136d2&scoped=true&ts=true"
import script from "./ScrollablePanels.vue?vue&type=script&lang=ts"
export * from "./ScrollablePanels.vue?vue&type=script&lang=ts"

import "./ScrollablePanels.vue?vue&type=style&index=0&id=964136d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-964136d2"]])

export default __exports__